module.exports = __webpack_public_path__ + "static/media/img-best-regional-home-warranty-award-color-years.1ddc34e2.png";